import { Button, Divider, Stack, styled, Typography } from '@mui/material';

const ClosedInputBackground = styled(Stack, {
  name: 'ClosedInputBackground',
})(({ theme }) => ({
  alignItems: 'end',
  backgroundColor: theme.palette.custom.OV.sys.surfaceBright,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  overflow: 'visible',
}));

const StyledButton = styled(Button, { name: 'ClosedInputSendButton' })(({ theme }) => ({
  background: theme.palette.custom.OV.sys.secondary,
  flexShrink: 0,
  marginTop: theme.spacing(1),
}));

interface ClosedInputProps {
  buttonText: string;
}

export const ClosedInput = ({ buttonText }: ClosedInputProps) => {
  return (
    <ClosedInputBackground>
      <Divider
        sx={{
          width: '100%',
        }}
      />
      <StyledButton variant="contained" disabled>
        <Typography variant="body2" sx={{ fontWeight: 900 }}>
          {buttonText}
        </Typography>
      </StyledButton>
    </ClosedInputBackground>
  );
};
